module.exports = __webpack_public_path__ + "static/media/Suggestions.ca0f2a82.svg";